// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for Amazon Route 53 Recovery Controls (ROUTE53-RECOVERY-CONTROL-CONFIG)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonroute53recoverycontrols.html
 *
 * 2025-02-24T21:49:30.871Z
 */
export enum AwsRoute53RecoveryControlConfigActions {
  /**
   * Grants permission to create a cluster
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/cluster.html
   */
  CreateCluster = 'route53-recovery-control-config:CreateCluster',
  /**
   * Grants permission to create a control panel
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/controlpanel.html
   */
  CreateControlPanel = 'route53-recovery-control-config:CreateControlPanel',
  /**
   * Grants permission to create a routing control
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/routingcontrol.html
   */
  CreateRoutingControl = 'route53-recovery-control-config:CreateRoutingControl',
  /**
   * Grants permission to create a safety rule
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/safetyrule.html
   */
  CreateSafetyRule = 'route53-recovery-control-config:CreateSafetyRule',
  /**
   * Grants permission to delete a cluster
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/cluster-clusterarn.html
   */
  DeleteCluster = 'route53-recovery-control-config:DeleteCluster',
  /**
   * Grants permission to delete a control panel
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/controlpanel-controlpanelarn.html
   */
  DeleteControlPanel = 'route53-recovery-control-config:DeleteControlPanel',
  /**
   * Grants permission to delete a routing control
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/routingcontrol-routingcontrolarn.html
   */
  DeleteRoutingControl = 'route53-recovery-control-config:DeleteRoutingControl',
  /**
   * Grants permission to delete a safety rule
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/safetyrule-safetyrulearn.html
   */
  DeleteSafetyRule = 'route53-recovery-control-config:DeleteSafetyRule',
  /**
   * Grants permission to describe a cluster
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/cluster-clusterarn.html
   */
  DescribeCluster = 'route53-recovery-control-config:DescribeCluster',
  /**
   * Grants permission to describe a control panel
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/controlpanel-controlpanelarn.html
   */
  DescribeControlPanel = 'route53-recovery-control-config:DescribeControlPanel',
  /**
   * Grants permission to describe a routing control
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/routingcontrol-routingcontrolarn.html
   */
  DescribeRoutingControl = 'route53-recovery-control-config:DescribeRoutingControl',
  /**
   * Grants permission to describe a routing control
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/routingcontrol-routingcontrolarn.html
   */
  DescribeRoutingControlByName = 'route53-recovery-control-config:DescribeRoutingControlByName',
  /**
   * Grants permission to describe a safety rule
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/safetyrule-safetyrulearn.html
   */
  DescribeSafetyRule = 'route53-recovery-control-config:DescribeSafetyRule',
  /**
   * Grants permission to get the resource policy of a cluster
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/cluster/resourcepolicy-resourcearn.html
   */
  GetResourcePolicy = 'route53-recovery-control-config:GetResourcePolicy',
  /**
   * Grants permission to list associated Route 53 health checks
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/routingcontrol-routingcontrolarn-associatedroute53healthchecks.html
   */
  ListAssociatedRoute53HealthChecks = 'route53-recovery-control-config:ListAssociatedRoute53HealthChecks',
  /**
   * Grants permission to list clusters
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/cluster.html
   */
  ListClusters = 'route53-recovery-control-config:ListClusters',
  /**
   * Grants permission to list control panels
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/controlpanels.html
   */
  ListControlPanels = 'route53-recovery-control-config:ListControlPanels',
  /**
   * Grants permission to list routing controls
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/controlpanel-controlpanelarn-routingcontrols.html
   */
  ListRoutingControls = 'route53-recovery-control-config:ListRoutingControls',
  /**
   * Grants permission to list safety rules
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/controlpanel-controlpanelarn-safetyrules.html
   */
  ListSafetyRules = 'route53-recovery-control-config:ListSafetyRules',
  /**
   * Grants permission to list tags for a resource
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/tags-resource-arn.html
   */
  ListTagsForResource = 'route53-recovery-control-config:ListTagsForResource',
  /**
   * Grants permission to tag a resource
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/tags-resource-arn.html
   */
  TagResource = 'route53-recovery-control-config:TagResource',
  /**
   * Grants permission to remove tags from a resource
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/tags-resource-arn.html
   */
  UntagResource = 'route53-recovery-control-config:UntagResource',
  /**
   * Grants permission to update a cluster
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/controlpanel.html
   */
  UpdateControlPanel = 'route53-recovery-control-config:UpdateControlPanel',
  /**
   * Grants permission to update a routing control
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/routingcontrol.html
   */
  UpdateRoutingControl = 'route53-recovery-control-config:UpdateRoutingControl',
  /**
   * Grants permission to update a safety rule
   *
   * See https://docs.aws.amazon.com/recovery-cluster/latest/api/safetyrule.html
   */
  UpdateSafetyRule = 'route53-recovery-control-config:UpdateSafetyRule',
}
